var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

export const handleGenerateCalendarLink = (type,startTime, endTime, location, title, description) =>{
    console.log('Event Description', description)
    const formattedDescription = description.replace(/\n/g, "\\n");
  
      if(type === 'apple' || type === 'outlook') {
        var calendarUrl = "";
        // calendarUrl = ["BEGIN:VCALENDAR", "VERSION:2.0", "BEGIN:VEVENT", "URL:" + document.URL, "DTSTART:" + formatTime(startTime), "DTEND:" + formatTime(endTime), "SUMMARY:" + title, "DESCRIPTION:" + formattedDescription, "LOCATION:" + location  + "", "END:VEVENT", "END:VCALENDAR"].join("\n");
        calendarUrl = ["BEGIN:VCALENDAR", "VERSION:2.0", "BEGIN:VEVENT", "DTSTART:" + formatTime(startTime), "DTEND:" + formatTime(endTime), "SUMMARY:" + title, "DESCRIPTION:" + formattedDescription, "LOCATION:" + location  + "", "END:VEVENT", "END:VCALENDAR"].join("\n");
        calendarUrl = encodeURI("data:text/calendar;charset=utf8," + calendarUrl);
          console.log('Calender Link', calendarUrl)
          window.open(calendarUrl, "_blank", "noreferrer");
        
      } else if(type === 'google') {
        var calendarUrl = "";
  
        console.log('Start time', startTime, 'End time', endTime )
        calendarUrl = "https://calendar.google.com/calendar/render";
        calendarUrl += "?action=TEMPLATE";
        calendarUrl += "&dates=" + formatTime(startTime);
        calendarUrl += "/" + formatTime(endTime);
        calendarUrl += "&location=" + encodeURIComponent(location);
        
        calendarUrl += "&text=" + encodeURIComponent(title);
        calendarUrl += "&details=" + encodeURIComponent(description); 
  
        console.log('Calender Link', calendarUrl)
        window.open(calendarUrl, "_blank", "noreferrer");
  
      } 
      // else if (type === 'outlook') {
      //   calendarUrl = "https://outlook.live.com/owa/?rru=addevent";
      //   calendarUrl += "&startdt=" + new Date(startTime).toISOString();
      //   calendarUrl += "&enddt=" + new Date(endTime).toISOString();
      //   calendarUrl += "&subject=" + encodeURIComponent(title);
      //   calendarUrl += "&location=" + encodeURIComponent(location);
      //   calendarUrl += "&body=" + encodeURIComponent(description);
      //   calendarUrl += "&allday=false";
      //   calendarUrl += "&uid=" + getRandomKey();
      //   calendarUrl += "&path=/calendar/view/Month";
  
      //       console.log('Calender Link', calendarUrl)
      //   window.open(calendarUrl, "_blank", "noreferrer");
      // }
  }


  function formatTime(date) {
    var formattedDate = _moment2.default.utc(date).format("YYYYMMDDTHHmmssZ");
    return formattedDate.replace("+00:00", "Z");
  }